import { Component, Vue, Prop, Model, Ref, Emit, Watch } from 'vue-property-decorator'
import { Observable } from 'rxjs'
import DForm from '@/components/DForm'

import { Schema } from '../DForm/types'

@Component
export default class FormModal extends Vue {
  @Ref() dForm: DForm

  @Model('change', { type: Boolean }) readonly visible!: boolean

  @Prop({ default: '标题' }) title: string
  @Prop({ default: 640 }) width: number
  @Prop({ default: () => ({}) }) schema: Schema

  loading = false

  @Watch('visible')
  onVisibleChange(val) {
    this.emitChange(val)
  }

  @Emit('change')
  emitChange(bool: boolean) {
    return bool
  }

  @Emit('submit')
  submit() {
    const { form } = this.dForm.formProps as any
    // form.validateFields((err, values) => {
    //   if (!err) {
    //     console.log(values)
    //   }
    // })
    return new Observable(subscriber => {
      form.validateFields((err, values) => {
        if (!err) {
          subscriber.next(values)
        }
      })
    })
  }

  render() {
    return (
      <a-modal
        v-model={this.visible}
        title={this.title}
        width={this.width}
        confirmLoading={this.loading}
        destroyOnClose
        maskClosable={false}
        okText={this.$t('submit')}
        onOk={this.submit}
      >
        <DForm ref="dForm" schema={this.schema} />
      </a-modal>
    )
  }
}
